import { Route } from '@angular/router';
import { RequirementBookingAssignmentComponent } from 'src/app/pages/campaigns/bookings/requirement-booking-assignment/requirement-booking-assignment.component';
import { RequirementEditComponent } from 'src/app/pages/campaigns/bookings/requirement-edit/requirement-edit.component';
import { RequirementsListComponent } from 'src/app/pages/campaigns/bookings/requirements-list/requirements-list.component';
import { RouteGuardService } from 'src/app/services/route-guard.service';
import { RoutingID } from '../../../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';

export const requirements: Route = {
  path: 'requirements/:commercialID',
  title: 'nav.campaigns.commercials.requirements',
  data: {
    breadcrumb: 'nav.campaigns.commercials.requirements',
    icon: SbIcons.crossway,
    id: RoutingID.requirements,
  },
  children: [
    {
      path: '',
      component: RequirementsListComponent,
      data: {
        breadcrumb: '',
      },
    },
    {
      path: 'requirement-edit/:requirementID',
      data: {
        breadcrumb: 'nav.campaigns.commercials.requirements.edit',
        icon: SbIcons.edit,
        id: RoutingID.requirementEdit,
      },
      children: [
        {
          path: '',
          canDeactivate: [RouteGuardService],
          component: RequirementEditComponent,
          data: {
            breadcrumb: '',
          },
        },
        {
          path: 'requirement-booking-assignment',
          title: 'nav.campaigns.commercials.requirements.bookingAssignment',
          data: {
            breadcrumb: 'nav.campaigns.commercials.requirements.bookingAssignment',
            icon: SbIcons.plus,
            id: RoutingID.requirementBookingAssignment,
          },
          children: [
            {
              path: '',
              component: RequirementBookingAssignmentComponent,
              data: {
                breadcrumb: '',
              },
            },
          ],
        },
      ],
    },
    {
      path: 'requirement-create',
      title: 'nav.campaigns.commercials.requirements.create',
      data: {
        breadcrumb: 'nav.campaigns.commercials.requirements.create',
        icon: SbIcons.plus,
        id: RoutingID.requirementCreate,
      },
      children: [
        {
          path: '',
          canDeactivate: [RouteGuardService],
          component: RequirementEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
  ],
};
